import { RouteRecordRaw } from 'vue-router';
import { GenerateRecordPage } from '@/pages/record-fill';

export const routeName = 'GerarRegistro';

export const route: RouteRecordRaw = {
  path: 'registros-da-qualidade/:prefix/gerar-registro/:matrixId',
  name: routeName,
  component: GenerateRecordPage,
  meta: {
    requiresAuth: true,
  },
};
